/**
 * Layout principal del panel de administración
 * Sprint 7 - HU-FE-04
 */

import { useState, useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores';
import { SystemToolsFabs } from '../location';
import { Sidebar } from './Sidebar';
import { FloatingActionDock, FloatingActionsProvider } from '../layout/floatingActions';

export function AdminLayout() {
    const navigate = useNavigate();
    const { user, logout } = useAuthStore();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleLogout = useCallback(async () => {
        await logout();
        navigate('/login');
    }, [logout, navigate]);

    const closeSidebar = useCallback(() => setSidebarOpen(false), []);
    const toggleSidebar = useCallback(() => setSidebarOpen((prev) => !prev), []);

    return (
        <FloatingActionsProvider>
            <div className="admin-layout">
                <a
                    href="#admin-main-content"
                    className="sr-only z-[1100] rounded-lg bg-surface px-4 py-3 text-sm font-semibold text-primary shadow-lg focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35"
                >
                    Saltar al contenido
                </a>
                <Sidebar
                    isOpen={sidebarOpen}
                    onClose={closeSidebar}
                    onLogout={handleLogout}
                />

                <div className="admin-main">
                    <header className="admin-header">
                        <button
                            type="button"
                            className="admin-menu-btn"
                            onClick={toggleSidebar}
                            aria-label="Abrir menú"
                        >
                            ☰
                        </button>
                        <h1 className="admin-header-title">Panel de Administración</h1>
                        <div className="admin-header-actions">
                            <button
                                type="button"
                                className="admin-settings-btn"
                                onClick={() => navigate('/settings')}
                                aria-label="Configuración"
                            >
                                ⚙️
                            </button>
                            <span className="admin-header-user">
                                {user?.name ?? 'Admin'}
                            </span>
                        </div>
                    </header>

                    <main id="admin-main-content" className="admin-content" tabIndex={-1}>
                        <Outlet />
                    </main>
                </div>

                <SystemToolsFabs />
                <FloatingActionDock />
            </div>
        </FloatingActionsProvider>
    );
}
